__turbopack_context__.v({
  "iconGroup": "BRqBVG_iconGroup",
  "iconGroupList": "BRqBVG_iconGroupList",
  "nav": "BRqBVG_nav",
  "navigationButtons": "BRqBVG_navigationButtons",
  "navigationButtons--loggedIn": "BRqBVG_navigationButtons--loggedIn",
});
